<div
  role="menu"
  aria-label="Sort and filter"
  class="flex w-98 flex-col gap-2 px-6 py-8"
  (keydown)="onMenuKeydown($event)"
>
  <span [id]="sortHeadingId" data-test="hub-sort-heading" class="block pl-4 text-variant-sm-medium text-gray-500">
    Sort by
  </span>
  <div data-test="hub-sort-section" role="group" [attr.aria-labelledby]="sortHeadingId" class="flex flex-col gap-1">
    @for (option of items(); track option.label) {
      <button
        #menuItem
        type="button"
        role="menuitemradio"
        data-test="hub-sort-option"
        [attr.aria-checked]="option.isActive"
        class="flex cursor-pointer items-center gap-4 rounded-md px-4 py-2 text-left text-variant-md focus-visible:outline focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-blue-600"
        [class]="option.isActive ? 'font-medium text-blue-600' : 'text-gray-950 hover:bg-gray-100'"
        (click)="handleSelect(option)"
      >
        <span data-test="hub-sort-option-label" class="min-w-0 flex-1 truncate">{{ option.label }}</span>
        @if (option.isActive) {
          <app-icon data-test="hub-sort-check" name="sapphire-check" [size]="16" class="shrink-0" />
        }
      </button>
    }
  </div>
  <div
    data-test="hub-filter-section"
    role="group"
    [attr.aria-labelledby]="filterHeadingId"
    class="mt-2 flex flex-col gap-2 border-t border-gray-200 pt-4"
  >
    <span [id]="filterHeadingId" data-test="hub-filter-heading" class="block pl-4 text-variant-sm-medium text-gray-500">
      Filter
    </span>
    @for (option of filterItems(); track option.key) {
      <button
        #menuItem
        type="button"
        role="menuitemcheckbox"
        data-test="hub-filter-option"
        [attr.aria-checked]="option.checked"
        class="flex cursor-pointer items-center gap-4 rounded-md pt-1 text-left text-variant-md text-gray-950 focus-visible:outline focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-blue-600"
        (click)="toggleFilter(option)"
      >
        <app-icon
          data-test="hub-filter-box"
          [name]="option.icon"
          [size]="20"
          class="shrink-0"
          [class]="option.checked ? 'text-blue-600' : 'text-gray-400'"
        />
        <span data-test="hub-filter-option-label">{{ option.label }}</span>
      </button>
    }
  </div>
</div>
